import { useEffect, useRef, useState } from 'react';
import type { Participant } from '@interactive-room';

export interface JoinToast {
  id: string;
  name: string;
}

export function useJoinToasts(participants: Participant[]) {
  const [toasts, setToasts] = useState<JoinToast[]>([]);
  const seenConnected = useRef(new Set<string>());
  const bootstrapped = useRef(false);

  useEffect(() => {
    const connected = participants.filter((p) => p.connected && p.role === 'student');

    if (!bootstrapped.current) {
      connected.forEach((p) => seenConnected.current.add(p.participantId));
      bootstrapped.current = true;
      return;
    }

    for (const p of connected) {
      if (seenConnected.current.has(p.participantId)) continue;
      seenConnected.current.add(p.participantId);

      const toast: JoinToast = { id: `${p.participantId}_${Date.now()}`, name: p.displayName };
      setToasts((prev) => [...prev, toast]);

      window.setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== toast.id));
      }, 4200);
    }
  }, [participants]);

  const dismiss = (id: string) => setToasts((prev) => prev.filter((t) => t.id !== id));

  return { toasts, dismiss };
}
